import * as React from 'react';
import styled from 'styled-components';
import { Col3Col6Col3d } from '../common';
import { InstructionsContainer, InstructionsText, InstructionsTitle } from '../common/styles/globalStyles';
import { BuildSurveyButton } from '../surveys/CopyTemplateModal/BuildSurveyButton';
export interface IEmptyListCardContentProps {
	instructionsTitle: string;
	instructionsText: string;
	canUserAccessCopyFromTemplate: boolean;
	mainButtonClick: () => void;
}
export const ContentContainer = styled.div`
	text-align: center;
	position: relative;
	margin-top: 175px;
	margin-bottom: 135px;
	@media (min-width: 0) and (max-width: 768px) {
		margin-top: 95px;
	}
`;
ContentContainer.displayName = 'ContentContainer';

export class EmptyListCardContent extends React.Component<IEmptyListCardContentProps> {
	public render() {
		return (
			<ContentContainer>
				<Col3Col6Col3d>
					<InstructionsContainer>
						<InstructionsTitle>{this.props.instructionsTitle}</InstructionsTitle>
						<InstructionsText>{this.props.instructionsText}</InstructionsText>
					</InstructionsContainer>
					<BuildSurveyButton
						shouldShowDropdown={this.props.canUserAccessCopyFromTemplate}
						dropdownPositionX={215}
						dropdownPositionY={-1}
						buildNewSurvey={() => this.props.mainButtonClick()}
					/>
				</Col3Col6Col3d>
			</ContentContainer>
		);
	}
}
